export default __webpack_public_path__ + "static/NuvemFiscalNFSe-4232f32a4201b96b69354a7d41f2b05e.png";